import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { Card, Tabs, Typography } from 'antd';

import { hasPermission } from '../../../../helpers/user';

import { PERMISSIONS } from '../../../../constants/permissions';

import AppBreadcrumb from '../../../ui-components/AppBreadcrumb';

import GatewaysTable from './GatewaysTable';
import TagsTable from './TagsTable';

const { Title } = Typography;

export default function Devices() {
  const { search } = useLocation();
  const { permissions } = useSelector(state => state.user);
  const queryParams = new URLSearchParams(search);
  const tab = queryParams.get('tab');
  const history = useHistory();

  const tabItems = useMemo(() => {
    const items = [];

    if (hasPermission([PERMISSIONS.TAGS.VIEW_OWN], permissions)) {
      items.push({
        key: 'tags',
        label: 'Tags',
        children: <TagsTable />
      });
    }

    if (hasPermission([PERMISSIONS.GATEWAYS.VIEW_OWN], permissions)) {
      items.push({
        key: 'gateways',
        label: 'Gateways',
        children: <GatewaysTable />
      });
    }

    return items;
  }, [permissions]);

  const breadcrumbItems = [
    {
      title: 'List of Kraal Tags and Gateways'
    }
  ];

  const handleTabChange = (key) => {
    history.push({
      pathname: '/administration/devices',
      search: `?tab=${key}`
    })
  };

  return (
    <Card>
      <Title level={4}>Kraal Devices</Title>

      <AppBreadcrumb items={breadcrumbItems} />

      <Tabs defaultActiveKey={tab || tabItems[0]?.key} items={tabItems} onChange={handleTabChange} />
    </Card>
  );
}
